export enum ActionType {
  SET_ERROR = 'setError',
  SET_BY_STATUS = 'setByStatus',
  CLEAN_ERROR = 'cleanError'
}
